export const checkoutPageMessages = {
  title: 'Checkout',
  noStoryIdProvided: 'No story ID provided',
  storyNotFound: 'Story not found',
  checkoutWithStory: 'Checkout with story: {title}',
  storyId: 'Story ID: {id}',
  toastFailedToLoad: 'Failed to load story details',
  completeCheckoutButton: 'Get full story',
  generatingStory: 'Generating your story...',
  toastGeneratingStory: 'Generating the rest of your story...',
  toastStoryGenerated: 'Your story has been generated successfully!',
  toastStoryGenerationFailed:
    'Failed to generate your story. Please try again.',
} as const;
